import MojitoPresentation from 'mojito/presentation';
import TaxAbsorptionDisclaimer from 'modules/betslip/betslip-view/tax-absorption-disclaimer/index.js';
import MojitoServices from 'mojito/services';

const BetslipUtils = MojitoServices.Betslip.utils;

const { FlexPane, BetFunds } = MojitoPresentation.Components;
const {
    PayableInfo,
    FreebetStakeInfo,
    CashStakeInfo,
    StakeTaxInfo,
    StakeInfo,
    TotalPayoutInfo,
    PrewagerStakeInfo,
    PayoutInfo,
} = BetFunds;
const PlaceBetCalculations = ({
    calculationsHasAccaBoost,
    calculation,
    currencyCode = '',
    isSuspended,
    bonusInfo: { contributionSource, oddsBoostSubtype },
    mojitoTools: { config },
}) => {
    const {
        stake = 0,
        freebetStake = 0,
        cashStake = 0,
        stakeAfterTaxes = 0,
        stakeTax = 0,
        payout = NaN,
        payoutTax = 0,
        payoutNet = NaN,
        prewager,
        boostReturns,
    } = calculation;

    const getCalculationsValue = value => {
        return isSuspended ? NaN : value;
    };

    const funds = {
        currency: currencyCode,
        payout: getCalculationsValue(payout),
        payoutNet: getCalculationsValue(payoutNet),
        prewager,
        payoutTax,
        boostReturns,
    };

    const payoutInfoLabel = BetslipUtils.resolveBoostLabel(contributionSource, oddsBoostSubtype, {
        PROFIT: '$BET_FUNDS.BOOST_PROFIT',
        RETURN: '$BET_FUNDS.BOOST_RETURN',
        FIXED: '$BET_FUNDS.BOOST_FIXED',
    });

    return (
        <FlexPane config={config.calculationsContainer} class={'ta-totalStakeInfo'}>
            {stakeTax > 0 ? (
                <PayableInfo
                    config={config.totalPayable}
                    value={getCalculationsValue(stake)}
                    currencyCode={currencyCode}
                    class="ta-PayableInfo"
                />
            ) : (
                <StakeInfo
                    config={config.primaryTotalStake}
                    currencyCode={currencyCode}
                    value={getCalculationsValue(stake)}
                    class="ta-PrimaryTotalStake"
                />
            )}
            {prewager && (
                <PrewagerStakeInfo
                    config={config.prewagerStake}
                    prewager={prewager}
                    currencyCode={currencyCode}
                    class="ta-PrewagerStakeInfo"
                />
            )}
            {freebetStake > 0 && (
                <>
                    <CashStakeInfo
                        config={config.cashStake}
                        value={getCalculationsValue(cashStake)}
                        currencyCode={currencyCode}
                        class="ta-CashStakeInfo"
                    />
                    <FreebetStakeInfo
                        config={config.freebetStake}
                        value={getCalculationsValue(freebetStake)}
                        currencyCode={currencyCode}
                        class="ta-FreebetStakeInfo"
                    />
                </>
            )}
            {stakeTax > 0 && (
                <StakeTaxInfo
                    config={config.stakeTax}
                    value={getCalculationsValue(stakeTax)}
                    currencyCode={currencyCode}
                    class="ta-StakeTaxInfo"
                />
            )}
            {stakeTax > 0 && (
                <StakeInfo
                    config={config.secondaryTotalStake}
                    currencyCode={currencyCode}
                    value={getCalculationsValue(stakeAfterTaxes)}
                    class="ta-SecondaryTotalStake"
                />
            )}
            <TotalPayoutInfo
                class="ta-totalPayoutInfo"
                config={config.totalPayoutInfo}
                funds={funds}
                isBoosted={calculationsHasAccaBoost}
                isSuspended={isSuspended}
            />
            {boostReturns > 0 && (
                <PayoutInfo
                    config={config.oddsBoostInfo}
                    payout={boostReturns}
                    labelKey={payoutInfoLabel}
                    currencyCode={currencyCode}
                    class="ta-OddsBoostPayoutInfo"
                />
            )}
            <TaxAbsorptionDisclaimer
                config={config.taxAbsorptionDisclaimer}
                tax={payoutTax}
                currencyCode={currencyCode}
                class="ta-TaxAbsorptionDisclaimer"
            />
        </FlexPane>
    );
};

export default PlaceBetCalculations;
